import { columnHelper } from './helper';

export const podIp = columnHelper.accessor('podIp', {
  header: 'Pod IP',
  id: 'podIp',
});
